import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import BeforeAfter from "@/components/BeforeAfter";
import BookingForm from "@/components/BookingForm";
import QuoteCTA from "@/components/QuoteCTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Counters from "@/components/Counters";
import ServiceArea from "@/components/ServiceArea";
import VideoShowcase from "@/components/VideoShowcase";

export default function HomePage() {
  const scrollToBook = () => {
    document.getElementById("book")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="home-page" className="relative">
      <Navbar onCta={scrollToBook} />
      <Hero onBook={scrollToBook} />
      <Counters />
      <Services onBook={scrollToBook} />
      <BeforeAfter />
      <VideoShowcase />
      <ServiceArea />
      <QuoteCTA onBook={scrollToBook} />
      <BookingForm />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
